export function uniqBy<T extends Record<string, any>, K extends keyof T>(
  collection: Array<T> | undefined,
  key: K
): Array<T> {
  if (!collection) {
    return [] as Array<T>
  }

  const uniqKeys = new Set<T[K]>()
  const values: Array<T> = []
  collection.forEach((item) => {
    if (!uniqKeys.has(item[key])) {
      uniqKeys.add(item[key])
      values.push(item)
    }
  })

  return values
}
